let host
if (process.env.NODE_ENV === 'production') {
  if (process.env.CUSTOM_ENV === 'test') {
    host = 'https://t-saas-coupon.lepass.cn/cms/' // 测试环境
  } else if (process.env.CUSTOM_ENV === 'pre') {
    host = 'https://p-saas-coupon.lepass.cn/cms/' // 预发布环境
  } else if (process.env.CUSTOM_ENV === 'prd') {
    host = 'https://saas-coupon.leshuazf.com/cms/' // 正式环境
  } else if (process.env.CUSTOM_ENV === 'dev') {
    host = 'http://10.96.34.163:7892/cms/' // 开发环境
  }
} else {
  host = '/cms/'
}
// 账户登录模块
const login = {
  login: host + 'home/login',
  getValidCode: host + 'home/get-valid-code',
  getUserInfo: host + 'home/get-login-user-info',
  changePsd: host + 'home/change-passwd',
  logout: host + 'home/logout',
  sendVailCode: host + 'home/send-mobile-valid-code',
  checkVailCode: host + 'home/check-mobile-valid-code',
  forgetPsw: host + 'home/forget-password'
}
// 静态数据
const staticInfo = {
  roleStateList: host + 'static-info/user',
  couponType: host + 'static-info/coupon',
  bankList: host + 'bank/list',
  uploadPic: host + 'common-service/upload-pic',
  singleTransPic: host + 'common-service//single-transfer-pic-url',
  mccList: host + 'mcc/list',
  subBranchList: host + 'bank/subBranchList',
  uploadPicOSS: host + 'common-service/upload-pic-oss',
  getBranch: host + 'bankBranch/find-branch-by-areaCode',
  getAreaCode: host + 'bankBranch/get-area-code',
  getBankList: host + 'bank/getBankInstitution',
  getEnableBankList: host + 'bank/enableList'
}
// 用户模块
const user = {
  userList: host + 'userManage/list',
  editUser: host + 'userManage/edit',
  addUser: host + 'userManage/add',
  resetPsd: host + 'userManage/reset-password',
  miniAcountList: host + 'miniprogram/account/list',
  checkMiniAccount: host + 'miniprogram/account/check',
  addAgentAssist: host + 'userManage/AgentAssistUserAdd',
  editAgentAssist: host + 'userManage/AgentAssistUserEdit',
  searchAgent: host + 'agentInfo/getAgentById',
  bankMiniAcountList: host + 'miniprogram/account/bank-list',
  checkBankMiniAccount: host + 'miniprogram/account/bank-check',
  changeAgent: host + 'userManage/changeAgent',
  resourceList: host + 'menu/list',
  resourceAdd: host + 'menu/add-menu',
  resourceEdit: host + 'menu/edit-menu',
  resourceDelete: host + 'menu/delete-menu',
  roleList: host + 'role/list',
  roleEdit: host + 'role/edit'
}
// 银行模块
const bank = {
  bankPageList: host + 'bank/pageList',
  editBank: host + 'bank/edit',
  addBank: host + 'bank/add',
  relateBank: host + 'bank/ralative',
  relateBankList: host + 'bank/relativeBankList',
  updateRelateBank: host + 'bank/updateRelativeBank',
  bankExport: host + 'bank/export',
  updateManagerStatus: host + 'bank/updateManagerStatus',
  queryManager: host + 'bank/queryManager',
  deleteBank: host + 'bank/delete',
  exportBank: host + 'bank/export',
  addBatchBank: host + 'bank/add/batch',
  updateBankStatus: host + 'bank/updateStatus'
}
// 支行模块
const branch = {
  branchPageList: host + 'subbranch/pageList',
  editBranch: host + 'subbranch/edit',
  addBranch: host + 'subbranch/add',
  batchAddBranch: host + 'subbranch/add/batch',
  getBranchInfo: host + 'subbranch/bankInfo',
  updateBranchStatus: host + 'subbranch/updateStatus',
  relativeBranchList: host + 'subbranch/relativeBankList',
  operationRecords: host + 'operationRecord/bank/list',
  exportBranchList: host + 'subbranch/export',
  getBranchList: host + 'subbranch/branchList'

}
// 银行经理模块
const customManager = {
  managerPageList: host + 'bankManage/pageList',
  addManager: host + 'bankManage/add',
  editManager: host + 'bankManage/edit',
  batchAddManager: host + 'bankManage/add/batch',
  exportManager: host + 'bankManage/export',
  deleteManager: host + 'bankManage/delete',
  queryManagerList: host + 'bankManage/queryManagerList',
  updateMangerStatus: host + 'bankManage/updateStatus'
}
// 卡券模块
const activity = {
  couponList: host + 'couponManage/list',
  addCoupon: host + 'couponManage/add',
  checkStockId: host + 'couponManage/check-stockId',
  editCoupon: host + 'couponManage/edit',
  // getBindUser: host + 'couponManage/get-binduser'
  themeList: host + 'couponManage/themeList',
  uploadFile: host + 'couponManage/uploadFile',
  downloadFile: host + 'couponManage/downFile',
  queryBankList: host + 'bank/queryBankByArea',
  queryAutoBank: host + 'bank/queryBankByPosition',
  queryManager: host + 'bank/queryManager'
}
// 数据报表模块
const statistic = {
  reportCount: host + 'reportfrom-bank/get-count',
  reportList: host + 'reportfrom-bank/list',
  reportDetails: host + 'reportfrom-bank/detail-info',
  activityAgentTransList: host + 'activityAgentTrans/list',
  activityAgentTransExport: host + 'activityAgentTrans/export',
  queryListByName: host + 'activity/queryListByName',
  t1FlowList: host + 'settleFlow/t1FlowList',
  t1FlowExport: host + 'settleFlow/t1FlowExport',
  t0FlowList: host + 'settleFlow/t0FlowList',
  t0FlowExport: host + 'settleFlow/t0FlowExport',
  exportAutomationList: host + 'export-automation/list',
  addExportAutomation: host + 'export-automation/add',
  editExportAutomation: host + 'export-automation/edit',
  exportAutomationState: host + 'export-automation/edit-state',
  exportAutomation: host + 'export-automation/export',
  activityAgentTransCount: host + 'activityAgentTrans/count',
  bankFuzzySearch: host + 'bank/fuzzyList',
  activityFuzzySearch: host + 'activity/queryByFuzzyName',
  transactionDetailList: host + 'trade-data/list',
  exportTransactionList: host + 'trade-data/export'
}
// 手续费补贴活动
const subsidy = {
  activityList: host + 'activity/list',
  addActivity: host + 'activity/add',
  editActivity: host + 'activity/edit',
  merchantList: host + 'merchantManage/list',
  getMerchantBase: host + 'merchantManage/base/query',
  addMerchant: host + 'merchantManage/add',
  editMerchant: host + 'merchantManage/edit',
  addressList: host + 'address/area/list',
  addBatch: host + 'merchantManage/addBinded', // 已绑卡商户录入
  exportInfo: host + 'merchantManage/export_merchant_info',
  exportMerchant: host + 'merchantManage/export',
  exportTradeSummary: host + 'merchantManage/export_trade_info',
  exportTradeDetail: host + 'merchantManage/export_trade_detail',
  downloadIdCard: host + 'merchantManage/download-pic',
  editBindMerchant: host + 'merchantManage/editMerchant',
  bindCheckMerchant: host + 'merchantManage/bindCheck',
  bindCheckBatchMerchant: host + 'merchantManage/batch/bindCheck',
  exportTradeSummaryBank: host + 'merchantManage/export_trade_info_bank',
  exportAgentActivity: host + 'activity/export',
  deleteMerchant: host + 'merchantManage/bind/delete',
  uploadPdf: host + 'activity/uploadFile',
  previewActivity: host + 'activity/uploadview',
  getExportHead: host + 'merchantManage/export_merchant_info_header',
  updateActivityStatus: host + 'activity/updateActivityStatus',
  queryBindHistory: host + 'bindHistory/queryBindHistory',
  subsidyDetailList: host + 'activitySubsidyDisbursementDetail/list',
  exportSubsidyDetail: host + 'activitySubsidyDisbursementDetail/export',
  batchUpdate: host + '/merchantManage/batch/update',
  upShelves: host + '/activity/upShelves',
  agentSubsidyDetailList: host + 'activitySubsidyDisbursementDetail/agent-subsidy-list',
  exportAgentSubsidyDetail: host + 'activitySubsidyDisbursementDetail/agent-subsidy-export',
  agentSubsidyListDetail: host + 'activitySubsidyDisbursementDetail/agent-subsidy-list-detail',
  agentSubsidyDetailExport: host + '/activitySubsidyDisbursementDetail/agent-subsidy-list-detail-export',
  deleteActivity: host + 'activity/deleteActivity',
  deleteRealTimeMerchant: host + 'merchantManage/del',
  batchUpdateCard: host + 'merchantManage/batch/modifyBindStatus',
  batchOpenCard: host + 'merchantManage/batch/openCard',
  queryOpenHistory: host + 'bindHistory/queryOpenHistory', // 查询开开指派记录
  activityDataExport: host + 'activity/exportMerchant',
  activityConfigDataExport: host + 'activity/exportActivity',
  queryOpenCardStatusRecord: host + 'bindHistory/statusRecord', // 查询开卡状态变更记录
  queryMerchantDetails: host + 'merchantManage/info',
  editMerchantInfo: host + 'merchantManage/editInfo',
  queryOpenCardInfo: host + 'merchantManage/openCardInfo',
  queryOperationRecords: host + 'operationRecord/merchant/list',
  updateOpenCardInfo: host + 'merchantManage/editOpenCard',
  exportUnappointed: host + 'merchantManage/exportUnappointed',
  updateOpenCardAssign: host + 'merchantManage/appoint', // 变更开卡指派
  queryAssignPageList: host + 'assign/list', // 开卡指派列表查询
  queryAssignRecordList: host + 'assign/record-list', // 开卡指派记录查询
  updateAssign: host + 'assign/addAssign', // 变更开卡指派
  queryBankByMerchantId: host + 'bank/queryBankByActivityId', // 查询商户关联银行网点
  updateOpenCardStatus: host + 'merchantManage/editStatus', // 更新开卡状态
  exitActivity: host + 'merchantManage/quitActivity', // 退出活动
  batchExitActivity: host + 'merchantManage/batch/quitActivity', // 批量退出活动
  addMerchantCheck: host + 'merchantManage/addCheck', // 待开卡商户录入提示
  subsidyBatchAddUnBoundMerchant: host + 'merchantManage/batch/addSwitchActivityMerchant', // 批量导入切换活动待开卡商户
  subsidyBatchAddBoundMerchant: host + 'merchantManage/batch/addSwitchActivityBoundMerchant',
  synStatus: host + 'activitySubsidyDisbursementDetail/synStatus',
  queryBankSubsidyList: host + 'bankSubsidyActivity/list',
  exportBankSubsidyList: host + 'bankSubsidyActivity/export',
  getSubsidyBankList: host + 'bankSubsidyActivity/getBankList',
  getDisbursementList: host + 'bankSubsidyActivity/disbursementList',
  exportDisbursementList: host + 'bankSubsidyActivity/disbursementExport'
}
// 额度包补贴活动
const allowance = {
  allowanceMerchantList: host + 'allowance/merchant/list',
  addAllowanceMerchant: host + 'allowance/merchant/add/V1',
  setQuota: host + 'allowance/merchant/quota/config',
  quotaDetails: host + 'allowance/merchant/quota/detail',
  changeStatus: host + 'allowance/merchant/status/opt',
  exportAllowance: host + 'allowance/export',
  exportMonthQuota: host + 'allowance/exportByMonth',
  batchAddAllowanceMerchant: host + 'allowance/merchant/batch',
  quotaPages: host + 'allowance/merchant/quota/pages',
  quotaRemain: host + 'allowance/merchant/quota/remain',
  deduceQuota: host + 'allowance/merchant/quota/deduction',
  exportQuotaBasic: host + 'allowance/merchant/export',
  batchAddMerchant: host + 'merchantManage/batch/addMerchant',
  batchAddBoundMerchant: host + 'merchantManage/batch/addBoundMerchant',
  addVerify: host + 'allowance/quotaVerify/add',
  batchAddVerify: host + 'allowance/quotaVerify/batchAdd',
  merchantCheck: host + 'allowance/shareGroup/merchantCheck',
  shareGroupQuota: host + 'allowance/shareGroup/quota',
  shareGroupAdd: host + 'allowance/shareGroup/add',
  shareGroupOut: host + 'allowance/shareGroup/out',
  batchAppend: host + 'allowance/merchant/batch/append',
  batchCreateQuoteVerify: host + 'allowance/shareGroup/diff/batchConfigVerify',
  batchAddQuoteVerify: host + 'allowance/shareGroup/diff/batchAddVerify',
  batchCreateQuote: host + 'allowance/shareGroup/diff/batchConfig',
  batchAddQuote: host + 'allowance/shareGroup/diff/batchAdd'
}
// 下载中心
const downloadCenter = {
  downloadList: host + 'bankDownloadRecord/pageList',
  downloadRecord: host + 'bankDownloadRecord/download-file',
  deleteRecord: host + 'bankDownloadRecord/editStatus',
  sendEmail: host + 'bankDownloadRecord/download-send-email',
  getEmail: host + 'bankDownloadRecord/get-email',
  viewPassword: host + 'bankDownloadRecord/viewPassword'
}
// 自定义导出功能
const customExport = {
  getDocList: host + 'customExport/docList',
  getTemplateActivityList: host + 'customExport/activityList',
  getTemplateList: host + 'customExport/templateList',
  addTemplate: host + 'customExport/addTemplate',
  editTemplate: host + 'customExport/editTemplate',
  exportTemplate: host + 'customExport/export',
  getCustomExportHeader: host + 'customExport/templateHeader', // 获取模板表头选项
  abandonTemplate: host + 'customExport/editTemplateStatus'
}
// 银行推荐
const unionReceipt = {
  contactList: host + 'contact/list',
  editContact: host + 'contact/update',
  contactDetails: host + 'contact/detail',
  exportContact: host + 'contact/export',
  merchantRecordList: host + 'marketMerchantDeleteRecord/list',
  exportMerchantRecord: host + 'marketMerchantDeleteRecord/export',
  getActivityList: host + 'marketMerchantDeleteRecord/getActivityList',
  exportAllowanceData: host + 'marketMerchantDeleteRecord/exportAllowance',
  coupletMerchantList: host + 'couplet-merchant/list',
  applyActivityList: host + 'couplet-merchant/activity-list',
  applyActivity: host + 'couplet-merchant/add-merchant',
  applyRecord: host + 'couplet-merchant/record-list',
  exportCoupletMerchant: host + 'couplet-merchant/export',
  batchAddApply: host + 'couplet-merchant/batch/addBoundMerchant',
  importNoQuota: host + 'noQuotaMerchantRecordManager/batchImport',
  noQuotaList: host + 'noQuotaMerchantRecordManager/list',
  deleltNoQuota: host + 'noQuotaMerchantRecordManager/delete/',
  noQuotaExport: host + 'noQuotaMerchantRecordManager/export',
  quotaPackageList: host + 'ustQuotaConfig/quotaPackageList',
  quotaPackageExport: host + 'ustQuotaConfig/quotaPackageExport',
  quotaPackageDetail: host + 'ustQuotaConfig/quotaPackageDetail',
  quotaPackageDetailExport: host + 'ustQuotaConfig/quotaPackageDetailExport'
}
// 开卡管理
const openManage = {
  openMerchantList: host + 'bank/push/pageList',
  editOpenStatus: host + 'bank/push/edit',
  MerchantDistribute: host + 'bank/push/distribute'
}
// 活动推广
const activityExtension = {
  extensionActivityList: host + 'activity-extension/list',
  activitySign: host + 'activity-extension/sign_up',
  activityPush: host + 'activity-extension/push',
  activityBatchSign: host + 'activity-extension/admin_sign_up',
  activityBatchPush: host + 'activity-extension/admin_push',
  extensionRecord: host + 'activity-extension/admin_logs',
  img2base64: host + 'activity-extension/img2base64',
  activityExtensionList: host + 'activity-extension/list'
}
// 操作日志
const operation = {
  operationList: host + 'operationRecord/list',
  exportOperationList: host + 'operationRecord/export'
}
const api = Object.assign({}, login, user, bank, branch, customManager, activity, statistic, staticInfo, subsidy, allowance, downloadCenter, unionReceipt, openManage, activityExtension, operation, customExport)
export default api
